import { useMemo, useState } from 'react'
import { Input, Stack } from '@chakra-ui/react'

import { Upload, FormItem } from 'components'
import CustomFormFileCardToUploadFile from 'components/tools/CustomForm/commonComponents/CustomFormFileCardToUploadFile'
import CustomFormFileCardToGetFile from 'components/tools/CustomForm/commonComponents/CustomFormFileCardToGetFile'
import { UploadFile } from 'types'
import { CustomFormDocumentUploads } from '../..'

type Props = CustomFormDocumentUploads & {
  label: string
}

export default function CustomFormDocumentUpload({
  fileArrayPositions,
  label,
  question,
  questionKey,
  disabled,
}: Props) {
  const [file, setFile] = useState<UploadFile>()

  async function handleUpload(file: UploadFile) {
    if (!file) return
    setFile(file)
  }

  const defaultFileValues = useMemo(() => {
    if (question.answer) {
      const currentValues = question.answer

      return [
        currentValues[fileArrayPositions[0]] || 0,
        currentValues[fileArrayPositions[1]] || 0,
        currentValues[fileArrayPositions[2]] || 0,
      ]
    }

    return undefined
  }, [])

  const [fileId, fileSlug, archiveId] = defaultFileValues || [0, 0, 0]

  return (
    <Stack>
      <FormItem label={label}>
        <Upload isDisabled={disabled} onUpload={handleUpload} />
      </FormItem>

      <Input isDisabled hidden />

      {file && (
        <CustomFormFileCardToUploadFile
          questionKey={questionKey}
          currentFile={file}
          fileArrayPositions={fileArrayPositions}
        />
      )}

      {fileId !== 0 && fileSlug !== 0 && archiveId !== 0 && !file && (
        <CustomFormFileCardToGetFile
          fileId={fileId as string}
          fileSlug={fileSlug as string}
          archiveId={archiveId as string}
        />
      )}
    </Stack>
  )
}
